import LoadingIndicator from './LoadingIndicator'
import loadingIndicatorContainer from './loadingIndicatorContainer'

export default loadingIndicatorContainer(LoadingIndicator)
